import { Layout } from 'components/missed-deal-feedback/components/layout';
import { WithAdditionalInformation } from 'components/missed-deal-feedback/components/with-additional-information';
import { FormIdProps } from 'shared/props';

export function MissedDealFeedbackIdleForm({ formId }: FormIdProps) {
  return (
    <Layout.Wrapper>
      <Layout.Body>
        <WithAdditionalInformation formId={formId} />
      </Layout.Body>
    </Layout.Wrapper>
  );
}
